export default __webpack_public_path__ + "static/impact-ready-highlight-cd4a79d550e89043e4744338392a6585.svg";